import http from "infra/http";
import { useMutation } from "react-query";
import { FornecedorEndereco } from './../typings/index';

function usePutFornecedorEndereco(id?: string) {
    return useMutation(
        `/v1/fornecedor${id}/endereco`,
        (data: FornecedorEndereco) => {

            return http.put<{ endercoId: string }>(
                `/v1/fornecedor/${id}/endereco`,
                data
            );
        },
        { retry: false }
    );
}

export default usePutFornecedorEndereco;
